import { render, staticRenderFns } from "./listImage.vue?vue&type=template&id=35cd6670"
import script from "./listImage.vue?vue&type=script&lang=js"
export * from "./listImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports